import { Button } from "@mui/material"
import { exportPdf } from "../utils/exportPdf"

export default function DownloadPDF({tableRef, pdfTitle, sx, printString = "", content=""}) {
    
    return (
        <Button variant="contained" sx={sx || {}} onClick={() => {exportPdf(tableRef, pdfTitle, printString, content)}}>Export to PDF</Button>
    )
}